// extracted by mini-css-extract-plugin
module.exports = {"textFeedback":"LatestCurrentFirmwareVersion_textFeedback__1991_","textButton":"LatestCurrentFirmwareVersion_textButton__1liog"};